import { DependencyList, useEffect, useRef } from "react"

const useAnimationFrame = (
  delegate: (delta: number) => void,
  deps?: Readonly<Array<unknown>>
) => {
  const frame = useRef<number | undefined>()
  const previous = useRef<number | undefined>()
  
  const animate = (time: number) => {
    if (previous.current) {
      const delta = time - previous.current
      delegate(delta)
    }
    previous.current = time
    frame.current = requestAnimationFrame(animate)
  }

  useEffect(() => {
    frame.current = requestAnimationFrame(animate)
    return () => {
      if (!frame.current) return

      cancelAnimationFrame(frame.current)
    }
  }, deps)
}

export default useAnimationFrame
export { useAnimationFrame } // Exporting useAnimationFrame for named import
